import { tourTypeCrudConfig, type TourType } from '@/config/objects/tour-types';
import { CrudFormView, PageContainer } from '@startupquickstart/frontend';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Tour Type create/edit form page
 */
export function TourTypeFormPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  // If id is 'new', treat as create mode (id = undefined)
  const itemId = id === 'new' ? undefined : id;
  const isEdit = !!itemId;

  /**
   * Handle successful form submission
   */
  const handleSuccess = (tourType: TourType) => {
    // Navigate to the tour type detail page
    navigate(`/tour-types/${tourType.id}`);
  };

  const breadcrumbs = isEdit
    ? [
        { label: 'Home', href: '/' },
        { label: 'Tour Types', href: '/tour-types' },
        { label: 'Tour Type', href: `/tour-types/${itemId}` },
        { label: 'Edit', current: true },
      ]
    : [
        { label: 'Home', href: '/' },
        { label: 'Tour Types', href: '/tour-types' },
        { label: 'Create', current: true },
      ];

  return (
    <PageContainer>
      <CrudFormView
        config={tourTypeCrudConfig}
        itemId={itemId}
        breadcrumbs={breadcrumbs}
        onSuccess={handleSuccess}
      />
    </PageContainer>
  );
}
